/**
 * Converts an array into an object where the keys are the array indicies and the values are the corresponding array
 * elements. Used for submitting arrays to certain API endpoints.
 * @param {Array} array 
 */
function arrayToIndexedObject(array) {
    if (!Array.isArray(array)) {
        return {};
    }

    return array.reduce((obj, value, index) => {
        obj[index] = value;
        return obj;
    }, {});
}

export default arrayToIndexedObject;